import { createSelector } from '@ngrx/store'
import { RootState } from '../../root.model'
import { UserPolicy, UserRedux } from './user.reducer'

const userState = (state: RootState) => state.helios.user

export const selectCurrentUser = createSelector(
  userState,
  (state: UserRedux) => state.user,
)

export const selectUserPolicy = createSelector(
  userState,
  (state: UserRedux) => state.userPolicy,
)

export const selectLegacyUserId = createSelector(
  selectCurrentUser,
  user => user?.clearwaterData?.legacyUserId,
)

export const selectClientId = createSelector(
  selectCurrentUser,
  user => user?.clearwaterData?.clientId,
)

export const selectIsInternalUser = createSelector(
  selectClientId,
  clientId => clientId === 1, // Clearwater's client id is 1
)

/**
 * Single-source gate for the commentary feature.
 *
 * Access is granted per client by the `accessCommentary` entitlement, which
 * rolls the feature out client-by-client. Use this anywhere you'd otherwise
 * read `policy?.accessCommentary` directly, so every call site shares one gate.
 */
export function userHasCommentaryAccess(
  policy: UserPolicy | undefined | null,
): boolean {
  return !!policy?.accessCommentary
}

export function userHasNotificationsAccess(
  policy: UserPolicy | undefined | null,
): boolean {
  return policy?.accessNotifications === true
}
